import * as echarts from 'echarts'

// 图表主题配置
export const chartTheme = {
  // 主色调
  primary: {
    main: '#2E7D32',    // 深绿色
    light: '#5C8D5C',   // 中绿色（降低饱和度）
    lighter: '#8FAE8F', // 浅绿色（降低饱和度）
    lightest: '#B5C9B5' // 最浅绿色（降低饱和度）
  },
  
  // 辅助色
  secondary: {
    blue: '#2196F3',    // 蓝色
    orange: '#FF9800',  // 橙色
    purple: '#9C27B0',  // 紫色
    cyan: '#00BCD4',    // 青色
    deepOrange: '#FF5722', // 深橙色
    blueGrey: '#607D8B'    // 蓝灰色
  },

  // 文字颜色
  text: {
    primary: '#666666',
    secondary: '#999999'
  },

  // 背景色
  background: {
    light: 'rgba(180, 180, 180, 0.2)',
    gradient: {
      primary: {
        start: 'rgba(46, 125, 50, 0.3)',
        end: 'rgba(46, 125, 50, 0.1)'
      },
      secondary: {
        start: 'rgba(33, 150, 243, 0.3)',
        end: 'rgba(33, 150, 243, 0.1)'
      }
    }
  },

  // 图表配置
  chart: {
    // 饼图配置
    pie: {
      colors: [
        '#2E7D32',  // 深绿色
        '#4CAF50',  // 中绿色
        '#2196F3',  // 蓝色
        '#FF9800',  // 橙色
        '#9C27B0',  // 紫色
        '#00BCD4',  // 青色
        '#FF5722',  // 深橙色
        '#607D8B'   // 蓝灰色
      ]
    },
    
    // 柱状图配置
    bar: {
      primary: {
        color: '#2E7D32',
        emphasis: '#4CAF50'
      },
      secondary: {
        color: '#2196F3',
        emphasis: '#64B5F6'
      }
    },
    
    // 折线图配置
    line: {
      primary: {
        color: '#2E7D32',
        areaGradient: {
          start: 'rgba(46, 125, 50, 0.3)',
          end: 'rgba(46, 125, 50, 0.1)'
        }
      },
      secondary: {
        color: '#2196F3',
        areaGradient: {
          start: 'rgba(33, 150, 243, 0.3)',
          end: 'rgba(33, 150, 243, 0.1)'
        }
      }
    }
  }
}

// 获取饼图颜色
export const getPieChartColor = (index: number): string => {
  return chartTheme.chart.pie.colors[index % chartTheme.chart.pie.colors.length]
}

// 获取柱状图样式
export const getBarChartStyle = () => {
  return {
    color: chartTheme.chart.bar.primary.color,
    emphasis: {
      color: chartTheme.chart.bar.primary.emphasis
    }
  }
}

// 获取折线图样式
export const getLineChartStyle = (type: 'primary' | 'secondary' = 'primary') => {
  const config = chartTheme.chart.line[type]
  return {
    color: config.color,
    areaStyle: {
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        {
          offset: 0,
          color: config.areaGradient.start
        },
        {
          offset: 1,
          color: config.areaGradient.end
        }
      ])
    }
  }
} 